module.exports = __webpack_public_path__ + "439f4fd028a46896b99d192005479ccd.png";